/**
 * O endereço de uma arte do acervo clínico (`assets/clinical/`).
 *
 * O caminho não pode ser montado como texto (`/assets/clinical/...`): o Vite
 * de desenvolvimento serve a pasta do projeto inteira e a imagem aparece, mas o
 * build só leva para o `dist` o que o código importa — e na produção a escala
 * de alopecia virava uma lista de nomes, com 404 em cada imagem. O `glob`
 * abaixo faz o build copiar o acervo e devolve o endereço com hash.
 *
 * Arte que não existe no acervo devolve vazio, e a tela mostra o aviso de
 * "sem ilustração" em vez de uma imagem quebrada.
 */

const ACERVO = import.meta.glob('/assets/clinical/**/*.{png,jpg,jpeg,webp,svg}', {
    eager: true,
    query: '?url',
    import: 'default',
}) as Record<string, string>;

/** `caminho` relativo a `assets/clinical/`, ex.: `escalas/alopecia-areata/unifocal.png`. */
export function urlDaArteClinica(caminho: string): string {
    return ACERVO[`/assets/clinical/${caminho}`] ?? '';
}
